export default {
    type: 'specialisations',
    aliases: {
        camel: 'specialisations',
        singular: 'Specialisation',
        plural: 'Specialisations',
        lowerSingular: 'specialisation',
        lowerPlural: 'specialisations',
    },
    relations: {},
    publishable: true,
    adminSection: 'about',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerSpecialisationRecord',
            loader: () => import('./AdministerSpecialisationRecord')
        },
        webRecord: {
            name: 'DisplaySpecialisationRecord',
            loader: () => import('./DisplaySpecialisationRecord')
        }
    },
};
